import { render, staticRenderFns } from "./ListEntryFieldReadonly.vue?vue&type=template&id=327b4f80"
import script from "./ListEntryFieldReadonly.vue?vue&type=script&lang=ts"
export * from "./ListEntryFieldReadonly.vue?vue&type=script&lang=ts"
import style0 from "./ListEntryFieldReadonly.vue?vue&type=style&index=0&id=327b4f80&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports